import get from "lodash/get";
import BaseComponent from "foundation/base-component";
import ScoringLoader, {
    endpointNames,
} from "general/js/loaders/scoring-loader";
import store from "general/js/store";

class StickyButtonTriggerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.windowObjectReference = null;
        this.unsubscribe = null;
        this.state = {
            title: this.options.title,
            isActive: this.options.isActive || false,
            openInPopup: this.options.openInPopup || false,
        };

        this.init();
    }

    init() {
        if (this.state.openInPopup) {
            this.addListener(this.element, "click", this.onClickRoot);
        }
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
        this.unsubscribe = store.subscribe(this.onStoreUpdate);
    }

    onDestroy() {
        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
        this.unsubscribe();
    }

    onStoreUpdate = () => {
        const state = store.getState();
        const config = get(state, "scoring.liveScanner.streamsConfig");

        if (!config || !config.radio) return;

        if (this.state.isActive !== config.radio.show) {
            this.state.isActive = config.radio.show;
            this.update();
        }
    };

    onClickRoot = (event) => {
        if (this.state.isActive) {
            // we should switch to sync logic there because of the way we handle showWindow
            // basically the theory behind is that the browser will treat window.open as a spam
            // and block it in case of any delay between the user action (trusted event) and actual window.open
            // we can't show window after passed challenge because it takes a lot of time and window will be blocked
            // and we have to do nothing first time and only on second click show window synchronously
            // we do so by passing second parameter equals true
            //emailCapturingService.challenge(() => {
            this.showWindow(this.element.href);
            //}, true);
        }

        event.preventDefault();
    };

    showWindow(url) {
        if (!url) return;

        if (this.windowObjectReference && !this.windowObjectReference.closed) {
            this.windowObjectReference.focus();
            return;
        }

        this.windowObjectReference = window.open(
            url,
            this.options.title,
            "left=150,top=150,width=780,height=780,resizable,scrollbars=0,status=1"
        );

        // make window be square in all browsers
        setTimeout(() => {
            this.windowObjectReference.document.documentElement.style.overflow =
                "hidden";
            this.windowObjectReference.innerWidth = 400;
            this.windowObjectReference.innerHeight = 400;
        }, 300);
    }

    update = () => {
        if (this.state.isActive) {
            this.element.classList.add("is-active");
            this.element.classList.remove("inactive");
        } else {
            this.element.classList.remove("is-active");
            this.element.classList.add("inactive");
        }
    };
}

export default StickyButtonTriggerComponent;
